import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  useMsal
  // useIsAuthenticated
} from '@azure/msal-react';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
// icons comented out till first release -start
// import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
// icons comented out till first release -end
// import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';
import SettingsIcon from '@mui/icons-material/Settings';
import SocialLinks from '../../common/SocialLinks/SocialLinks';
import BottomLinks from '../../common/BottomLinks/BottomLinks';
import logo2 from '../../../Assets/images/Airswift Primary Logo (Gradient Bird Only).png';
import logo from '../../../Assets/images/Airswift Primary Logo (White Text).png';
import styles from './sidebar.module.scss';
import CookieButton from '../../hubspotButton/CookieButton';
import { useWindowSize } from '../../../utils/hooks';
import FileFolderEditIcon from '../../common/Icons/FileFolderEditIcon';
import { getCookie } from '../../../utils/helpers';
import configData from '../../../config.json';

// import { SignInButton } from "../SignInButton";
// import { SignOutButton } from "../SignOutButton";

function SideLink({ url, icon, label, onclick, className }) {
  return (
    <li className={`${styles.li_navlink} ${className} nav-item w-100`}>
      <Link
        to={url}
        className="nav-link py-3"
        title=""
        data-bs-toggle="tooltip"
        onClick={onclick}
        data-bs-placement="right"
        data-bs-original-title="Dashboard"
      >
        {icon}
        <span className={`${styles.label}`}>{label}</span>
      </Link>
    </li>
  );
}

// function BottomLinks({
//   url,
//   label,
// }) {
//   return (
//     <a href={`${url}`} className={styles.nav_link_bottom} title="">
//       <span className={`d-inline ${styles.label}`}>{label}</span>
//     </a>
//   );
// }

export function Sidebar({ logout, toggleSidebar }) {
  const size = useWindowSize();
  const [nav, setNav] = useState(false);
  const [accessToOnboarding, setAccessToOnboarding] = useState(
    getCookie(configData.TIFO_ONBOARDING_KEY)
      ? getCookie(configData.TIFO_ONBOARDING_KEY) === configData.TIFO_ONBOARDING_VALUE
      : false
  );

  const [t] = useTranslation();
  const privacyLabel = 'common.footer.privacy';

  useEffect(() => {
    if (size.width <= 596) {
      setNav(false);
      return;
    }

    if (size.width < 768) {
      setNav(true);
    }
  }, [size.width]);

  useEffect(() => {
    toggleSidebar(nav);
  }, [nav]);

  useEffect(() => {
    setInterval(
      () =>
        setAccessToOnboarding(
          getCookie(configData.TIFO_ONBOARDING_KEY)
            ? getCookie(configData.TIFO_ONBOARDING_KEY) === configData.TIFO_ONBOARDING_VALUE
            : false
        ),
      1000
    );
  }, []);

  return (
    <nav className={`${styles.sidebar_container_grid_item} ${nav ? styles.sidebar_small : ''}`}>
      <div className={styles.logo_containter}>
        <Link to="/dashboard" className="text-center w-100">
          <img alt="logo" src={logo} className={styles.primary_logo} />
          <img alt="logo" src={logo2} className={styles.small_logo} />
        </Link>
      </div>
      <div className={`${styles.sidebar_shrink}`}>
        <a
          data-testid="switch"
          href="#"
          className="nav-link px-0"
          title=""
          data-bs-toggle="tooltip"
          onClick={() => {
            setNav(!nav);
          }}
          data-bs-placement="right"
        >
          <ExitToAppOutlinedIcon />
        </a>
      </div>
      <ul className={styles.link_list}>
        <SideLink className={styles.home_link} url="/dashboard" icon={<HomeOutlinedIcon />} label="Home" />
        <SideLink
          className={styles.jobs_hover}
          url="/dashboard/Jobs"
          icon={<WorkOutlineIcon />}
          label={t('dashboard.jobs.job')}
        />
        {accessToOnboarding && (
          <SideLink
            className={styles.jobs_hover}
            url="/dashboard/tifo"
            icon={<FileFolderEditIcon />}
            label={t('common.header.menu.onboarding')}
          />
        )}
        {/* Temporarily commented out until first release */}
        {/* <SideLink */}
        {/*   url="/dashboard/time-and-expense" */}
        {/*   icon={<TimerOutlinedIcon />} */}
        {/*   label="Time and Expense" */}
        {/* /> */}

        <div className={`mt-auto mb-4 ${styles.sidebar_bottom}`}>
          <SideLink url="#" icon={<LogoutIcon />} label={t('common.header.menu.signout')} onclick={logout} />
          <SideLink url="/my-profile" icon={<SettingsIcon />} label={t('common.header.menu.settings')} />
          <div className={`w-100 p-3 px-4 text-center ${styles.link_bottom}`}>
            {/* <BottomLinks
                url="#"
                label="SITEMAP"
              /> .  */}
            <CookieButton className="sidebar" />{' '}
            <BottomLinks url="https://www.airswift.com/privacy-cookie-policy/" label={t(privacyLabel)} /> .{' '}
            <BottomLinks url="https://www.airswift.com/" label="AIRSWIFT ©" />
          </div>
          <div className={`w-100 text-center  ${styles.link_bottom}`}>
            <SocialLinks url="https://www.facebook.com/weareairswift" icon={<FacebookIcon fontSize="small" />} />
            <SocialLinks url="https://www.linkedin.com/company/airswift/" icon={<LinkedInIcon fontSize="small" />} />
            <SocialLinks url="https://www.twitter.com/weareairswift" icon={<TwitterIcon fontSize="small" />} />
            <SocialLinks
              url="https://www.youtube.com/channel/UC36v2qP1q2Gj-mXyGZ9czzQ/featured"
              icon={<YouTubeIcon fontSize="small" />}
            />
            <SocialLinks url="https://www.instagram.com/weareairswift" icon={<InstagramIcon fontSize="small" />} />
          </div>
        </div>
      </ul>
    </nav>
  );
}
